export default __webpack_public_path__ + "static/media/down.96e594d4.svg";